import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { adminOidcConfigurationsByCustomerByIdReducers, adminOidcConfigurationsByCustomerByIdWatchers } from './_id';

export const adminOidcConfigurationsByCustomerReducers = combineReducers({
	byId: adminOidcConfigurationsByCustomerByIdReducers
});

export const adminOidcConfigurationsByCustomerWatchers = combineAllWatchers([
	adminOidcConfigurationsByCustomerByIdWatchers
]);
